import { useState, useEffect } from "react";
import { Drawer, Select, Modal } from "antd";
import { message } from "../../components/antdMessageBridge";
import { CloseCircleOutlined } from "@ant-design/icons";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { Html5QrcodeScanType } from "html5-qrcode";
import "../manifest_verificationqueue/verification-slider.css";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import CommonObj from "../../CommonObj";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import regexService, { removeSpaces } from "../../components/commonregex/regexService";
import PropTypes from "prop-types";

const ScanSliderUI = (props) => {
    const [accordionView] = useState(false);
    const [activeScanner1, setActiveScanner1] = useState(null);
    const [form, setForm] = useState({
        bid: "",
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        language: "",
        qcErrorCategory: "",
        weight: 0.75,
        isbn: "",
        condition: "",
        qcaction: "",
        bookType: "",
        usedCondition: "",
        content: "",
        bookFormat: "",
        errcount: "",
        comments: "",
        reasonForException: "",
        formatException: "",
        rackAndShelf: "",
        rackShelf: "",
        version: "",
        rejectRackShelf: ""
    });
    
    const { accessToken } = useAuthToken();
    const [errors, setErrors] = useState({});
    const [regexLoaded, setRegexLoaded] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [cusdectext, setCusDecText] = useState("");
    const [scanimage, setScanImage] = useState(false);
  const BarcodeScan = async () => {
    if (!scanimage || cusdectext.trim() === "") return;

    setScanImage(false);

  };
    useEffect(() => {
        delete form?.rackAndShelf;
        setForm((prev) => ({ ...prev, rackAndShelf: props?.formdata?.NrackAndShelf }));
    }, [props?.formdata?.NrackAndShelf]);
      useEffect(() => {
        if (scanimage && cusdectext.trim() !== "") {
          BarcodeScan();
          setScanImage(false);
          setActiveScanner1(null);
          setCusDecText("");
        }
      }, [scanimage, cusdectext]);

    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);

    const validate = () => {
        const newErrors = {};
        if (!form.qcaction || !form.qcaction.trim()) {
            newErrors.qcaction = "Scanning action is required";
        }
        if (
            (form.qcaction === "Reject" && !form?.qcrejecttype)
            && !form?.qcrejecttype?.value?.trim()
        ) {
            newErrors.qcrejecttype = "Rejection type is required";
        }
        if ((form.qcaction === "Rework" && !form?.rackAndShelf)
            && !form?.rackAndShelf?.value?.trim()
        ) {
            newErrors.rackAndShelf = "Rack and Shelf is required";
        }
        if ((form.qcaction === "Reject" && !form?.rejectRackShelf)
            && !form?.rejectRackShelf?.value?.trim()
        ) {
            newErrors.rejectRackShelf = "Rack and Shelf is required";
        }
        else if (form.qcaction === "Reject" && removeSpaces(form?.rejectRackShelf)?.toLowerCase() === removeSpaces(props?.formdata?.rackShelf)?.toLowerCase()) {
            newErrors.rejectRackShelf =
                "Books sent for reject cannot be placed in the same rack. Please scan the new rack";
        }
        else if (form.qcaction === "Reject" && regexLoaded && form?.rejectRackShelf.trim()) {
            const validation = regexService.validateRackShelf(form?.rejectRackShelf.trim());
            if (!validation.isValid) {
                newErrors.rejectRackShelf = "Input format invalid: No matching pattern found.";
            }
        }
        else if (form.qcaction === "Rework" && removeSpaces(form?.rackAndShelf)?.toLowerCase() === removeSpaces(props?.formdata?.rackShelf)?.toLowerCase()) {
            newErrors.rackAndShelf =
                "Books sent for rework cannot be placed in the same rack. Please scan the new rack";
        }
        else if (form.qcaction === "Rework" && regexLoaded && form?.rackAndShelf?.trim()) {
            const validation = regexService.validateRackShelf(form?.rackAndShelf?.trim());
            if (!validation.isValid) {
                newErrors.rackAndShelf = "Input format invalid: No matching pattern found.";
            }
        }
        console.log(newErrors);
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsDisabled(true);
        setTimeout(() => setIsDisabled(false), 3000);

        if (!validate()) {
            focusFirstError();
            return;
        }

        message.destroy();

        try {
            const { url, successMessage, submissionData } = prepareSubmissionData();
            const response = await submitData(url, submissionData);

            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }
            props?.disableRadio(false)
            handleSuccess(successMessage);
        } catch (error) {
            message.error("Error submitting form: " + error.message, 5);
        }
    };

    const focusFirstError = () => {
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField) {
            const element = document.getElementById(firstErrorField);
            if (element) element.focus();
        }
    };

    const prepareSubmissionData = () => {
        if (form.qcaction === "Reject") {
            return {
                url: CommonObj.Endpoints.GetScanningReject,
                successMessage: "Rejection submitted successfully",
                submissionData: {
                    bid: props.bid,
                    rejectComments: form?.comments || "",
                    rejectType: form?.qcrejecttype,
                    rackandShelfId: form?.rackAndShelf !== undefined && form?.rackAndShelf !== ""
                        ? form?.rackAndShelf
                        : (props?.formdata?.NewrackAndShelf !== "" && props?.formdata?.NewrackAndShelf !== 1
                            ? props?.formdata?.NewrackAndShelf
                            : props?.formdata?.rackShelf),
                    rejectRackandShelfId :  form.rejectRackShelf,    
                    createdBy: props.created,
                    bidScanTime: props?.formdata?.bidScanTime || ""
                }
            };
        } else {
            return {
                url: CommonObj.Endpoints.GetReworkSubmit,
                successMessage: "Rework submitted successfully",
                submissionData: {
                    bid: props.bid,
                    rackAndShelf: form?.rackAndShelf !== undefined && form?.rackAndShelf !== ""
                        ? form?.rackAndShelf
                        : props?.formdata?.rackShelf,
                    reasonForRework: form?.comments || "",
                    createdBy: props.created,
                    bidScanTime: props?.formdata?.bidScanTime || ""
                }
            };
        }
    };

    const submitData = async (url, data) => {
        return fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                "X-CSRF-Token": encryptTimestamp()
            },
            body: JSON.stringify(data),
        });
    };

    const handleSuccess = (successMessage) => {
        message.success(successMessage);
        resetForm();
        props.onClose();
        if (props?.clearForm) props.clearForm();
    };

    const resetForm = () => {
        setForm({
            bid: "",
            title: "",
            author: "",
            publisher: "",
            isbN10: "",
            isbN13: "",
            bookPageCount: "",
            language: "",
            qcErrorCategory: "",
            weight: 0.75,
            isbn: "",
            condition: "",
            qcaction: "",
            bookType: "",
            usedCondition: "",
            content: "",
            bookFormat: "",
            errcount: "",
            comments: "",
            reasonForException: "",
            formatException: "",
            rackAndShelf: "1",
            rackShelf: "",
            version: "",
            qcmoveToNextStation: "Cutting",
            NewrackAndShelf: "",
        });
        setErrors({});
    };

  const onNewScanResult = (decodedText) => {
    setCusDecText(decodedText);
    setForm({ ...form, rejectRackShelf: decodedText });
    setScanImage(true);
  };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "rackAndShelf") {
            delete props?.formdata?.NrackAndShelf;
        }
        setForm((prev) => {
            const updatedForm = { ...prev, [name]: value };
            return updatedForm;
        });
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
        if (name === "qcaction" && value !== "Rework") {
            delete errors.rackAndShelf;
            return errors;
        }
    };

    const handleMoveTostationChange = (e) => {
        setForm((prev) => ({ ...prev, qcMoveToNextStation: e }));

        if (errors['qcMoveToNextStation']) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors['qcMoveToNextStation'];
                return newErrors;
            });
        }
    };

    const handleqcrejecttype = (e) => {
        setForm((prev) => ({ ...prev, qcrejecttype: e }));

        if (errors['qcrejecttype']) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors['qcrejecttype'];
                return newErrors;
            });
        }
    };

    return (
        <>
            <Modal
                title={`Scan ${activeScanner1 ? activeScanner1 : ""}`}
                open={!!activeScanner1}
                onCancel={() => setActiveScanner1(null)}
                footer={null}
                destroyOnClose
                className="scan-model-container"
                width={1000}
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={20}
                        qrbox={500}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <Drawer
                title={props.title}
                placement={props.placement}
                onClose={props.onClose}
                open={props.visible}
                width={props.width}
                className={props.className}
                closeIcon={<CloseCircleOutlined />}
            >
                <div className="qc-failure-container">
                    <div
                        className={`${"delivery-rules-container"} ${accordionView ? "active" : ""
                            }`}
                    >
                    </div>

                    <form
                        className="qc-failure-form-container"
                        onSubmit={handleSubmit}
                        noValidate
                    >
                        <div className="qc-action-radio-container">
                            <p className="qc-action-radio-title">
                                Select Action <span className="form-required">*</span>
                            </p>

                            <div className="qc-action-radio-button">
                                <input
                                    type="radio"
                                    name="qcaction"
                                    id="qc-action-radio-self-fixed"
                                    value="Reject"
                                    onChange={handleChange}
                                />
                                <label htmlFor="qc-action-radio-self-fixed">Reject</label>
                            </div>
                            <div className="qc-action-radio-button">
                                <input
                                    type="radio"
                                    name="qcaction"
                                    id="qc-action-radio-rework"
                                    value="Rework"
                                    onChange={handleChange}
                                />
                                <label htmlFor="qc-action-radio-rework">Rework</label>
                            </div>
                            {errors.qcaction && (
                                <span className="error-msg">{errors.qcaction}</span>
                            )}
                        </div>
                        {form.qcaction === "Rework" && (
                            <div className="field-group select-container">
                                <input
                                    id="qcMoveToNextStation"
                                    name="qcMoveToNextStation"
                                    className={`book-page-form-input-text has-text`}
                                    value="Cutting"
                                    onChange={handleMoveTostationChange}
                                    disabled
                                />
                                <label htmlFor="qcMoveToNextStation">
                                    Move to <span className="form-required">*</span>
                                </label>
                                {errors.qcMoveToNextStation && (
                                    <span className="error-msg">{errors.qcMoveToNextStation}</span>
                                )}
                            </div>
                        )}
                        {form.qcaction === "Reject" && (
                            <div className="field-group select-container">
                                <Select
                                    id="qcrejecttype"
                                    className={`book-page-form-input-text has-text`}
                                    placeholder="Select a Reason"
                                    name="qcrejecttype"
                                    defaultValue={form?.qcrejecttype}
                                    style={{ width: 200 }}
                                    options={props?.rejectType}
                                    onChange={handleqcrejecttype}
                                    notFoundContent="No Rejection Reasons Available"
                                />

                                <label htmlFor="qcrejecttype">
                                    Reject Reason <span className="form-required">*</span>
                                </label>
                                {errors.qcrejecttype && (
                                    <span className="error-msg">{errors.qcrejecttype}</span>
                                )}
                            </div>
                        )}
                         {form.qcaction === "Rework" &&
                        <div className="field-group span2column margin-top-20">
                            <textarea
                                id="comments"
                                rows="3"
                                value={form.comments}
                                onChange={(e) =>
                                    setForm((prev) => ({ ...prev, comments: e.target.value }))
                                }
                                className={`${"book-page-form-input-textarea"} ${form.content === "" ? "" : "has-text"
                                    }`}
                            ></textarea>

                            <label htmlFor="" className="comment-input-label-indent">
                                Reason For {`${form.qcaction === "Rework" ? " Rework" : "Reject"
                                    }`}
                            </label>
                        </div>
}
                        {form.qcaction === "Rework" && (<div className="book-page-form-scan-rack-container  bgColor colSpan2lg">
                            <span className={`${form.qcaction === "Rework" ? "form-required-rack" : "hide"
                                }`} >*</span>
                            <input
                                className="book-page-form-scan-rack-button"
                                id="rackAndShelf"
                                name="rackAndShelf"
                                placeholder="Enter / Scan New Rack Shelf Barcode"
                                value={form.rackAndShelf !== "" ? form.rackAndShelf : props?.formdata?.NrackAndShelf}
                                onChange={handleChange}
                                required
                            ></input>

                            <button
                                className="book-page-form-scan-rack-button-icon"
                                data-track="scanning-slide-rework-open-rack-scanner"
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.emptyDecode(); 
                                    props.onScannerOpen("New Rack & Shelf ID"); 
                                }}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.00098 1C6.00098 0.447715 6.41425 0 6.92405 0H13.0779C13.5877 0 14.001 0.447715 14.001 1C14.001 1.55228 13.5877 2 13.0779 2H6.92405C6.41425 2 6.00098 1.55228 6.00098 1Z" fill="url(#paint0_linear_2146_40101)" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.77875 18H12.2232C15.3442 18 16.9047 18 18.0257 17.2777C18.511 16.965 18.9277 16.5632 19.252 16.0953C20.001 15.0143 20.001 13.5095 20.001 10.4999C20.001 7.49027 20.0008 5.9857 19.2518 4.90473C18.9275 4.43676 18.5109 4.03497 18.0256 3.72228C16.9046 3 15.3441 3 12.223 3H7.77859C4.65756 3 3.09705 3 1.97605 3.72228C1.49077 4.03497 1.0741 4.43676 0.749835 4.90473C0.000976503 5.98547 0.000976526 7.48961 0.000976563 10.4979L0.000976563 10.4999C0.000976563 13.5095 0.000976622 15.0143 0.750001 16.0953C1.07426 16.5632 1.49093 16.965 1.97622 17.2777C3.09721 18 4.65773 18 7.77875 18ZM5.83431 10.4999C5.83431 8.28085 7.69979 6.48196 10.001 6.48196C12.3022 6.48196 14.1676 8.28085 14.1676 10.4999C14.1676 12.7189 12.3022 14.5178 10.001 14.5178C7.69979 14.5178 5.83431 12.7189 5.83431 10.4999ZM7.50098 10.4999C7.50098 9.16846 8.62027 8.08913 10.001 8.08913C11.3817 8.08913 12.501 9.16846 12.501 10.4999C12.501 11.8313 11.3817 12.9106 10.001 12.9106C8.62027 12.9106 7.50098 11.8313 7.50098 10.4999ZM16.1121 6.48196C15.6519 6.48196 15.2788 6.84174 15.2788 7.28554C15.2788 7.72935 15.6519 8.08913 16.1121 8.08913H16.6676C17.1279 8.08913 17.501 7.72935 17.501 7.28554C17.501 6.84174 17.1279 6.48196 16.6676 6.48196H16.1121Z" fill="url(#paint1_linear_2146_40101)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_2146_40101" x1="20.601" y1="8.95028" x2="-0.0170404" y2="11.3301" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_2146_40101" x1="20.601" y1="8.95028" x2="-0.0170404" y2="11.3301" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <span className="error-msg-rad">{errors.rackAndShelf}</span>
                        </div>)}
                          {form.qcaction === "Reject" && (<div className="book-page-form-scan-rack-container  bgColor colSpan2lg">
                            <span className={`${form.qcaction === "Reject" ? "form-required-rack" : "hide"
                                }`} >*</span>
                            <input
                                className="book-page-form-scan-rack-button"
                                id="rejectRackShelf"
                                name="rejectRackShelf"
                                placeholder="Enter / Scan New Rack Shelf Barcode"
                                value={form?.rejectRackShelf}
                                onChange={handleChange}
                                required
                            ></input>

                            <button
                                className="book-page-form-scan-rack-button-icon"
                                data-track="scanning-slide-reject-open-rack-scanner"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setActiveScanner1("Rack & Shelf");
                                }}

                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.00098 1C6.00098 0.447715 6.41425 0 6.92405 0H13.0779C13.5877 0 14.001 0.447715 14.001 1C14.001 1.55228 13.5877 2 13.0779 2H6.92405C6.41425 2 6.00098 1.55228 6.00098 1Z" fill="url(#paint0_linear_2146_40101)" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.77875 18H12.2232C15.3442 18 16.9047 18 18.0257 17.2777C18.511 16.965 18.9277 16.5632 19.252 16.0953C20.001 15.0143 20.001 13.5095 20.001 10.4999C20.001 7.49027 20.0008 5.9857 19.2518 4.90473C18.9275 4.43676 18.5109 4.03497 18.0256 3.72228C16.9046 3 15.3441 3 12.223 3H7.77859C4.65756 3 3.09705 3 1.97605 3.72228C1.49077 4.03497 1.0741 4.43676 0.749835 4.90473C0.000976503 5.98547 0.000976526 7.48961 0.000976563 10.4979L0.000976563 10.4999C0.000976563 13.5095 0.000976622 15.0143 0.750001 16.0953C1.07426 16.5632 1.49093 16.965 1.97622 17.2777C3.09721 18 4.65773 18 7.77875 18ZM5.83431 10.4999C5.83431 8.28085 7.69979 6.48196 10.001 6.48196C12.3022 6.48196 14.1676 8.28085 14.1676 10.4999C14.1676 12.7189 12.3022 14.5178 10.001 14.5178C7.69979 14.5178 5.83431 12.7189 5.83431 10.4999ZM7.50098 10.4999C7.50098 9.16846 8.62027 8.08913 10.001 8.08913C11.3817 8.08913 12.501 9.16846 12.501 10.4999C12.501 11.8313 11.3817 12.9106 10.001 12.9106C8.62027 12.9106 7.50098 11.8313 7.50098 10.4999ZM16.1121 6.48196C15.6519 6.48196 15.2788 6.84174 15.2788 7.28554C15.2788 7.72935 15.6519 8.08913 16.1121 8.08913H16.6676C17.1279 8.08913 17.501 7.72935 17.501 7.28554C17.501 6.84174 17.1279 6.48196 16.6676 6.48196H16.1121Z" fill="url(#paint1_linear_2146_40101)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_2146_40101" x1="20.601" y1="8.95028" x2="-0.0170404" y2="11.3301" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_2146_40101" x1="20.601" y1="8.95028" x2="-0.0170404" y2="11.3301" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <span className="error-msg-rad">{errors.rejectRackShelf}</span>
                        </div>)}

                        <div className="modal-footer">
                            <button
                                className="modal-cancel-button"
                                type="button"
                                onClick={() => {
                                    setForm({
                                        bid: "",
                                        title: "",
                                        author: "",
                                        publisher: "",
                                        isbN10: "",
                                        isbN13: "",
                                        bookPageCount: "",
                                        language: "",
                                        qcErrorCategory: "",
                                        weight: 0.75,
                                        isbn: "",
                                        condition: "",
                                        qcaction: "",
                                        bookType: "",
                                        usedCondition: "",
                                        content: "",
                                        bookFormat: "",
                                        errcount: "",
                                        comments: "",
                                        reasonForException: "",
                                        formatException: "",
                                        rackAndShelf: "1",
                                        rackShelf: "",
                                        version: "",
                                        qcmoveToNextStation: ""
                                    });
                                    props.onClose();
                                }}
                            >
                                Cancel
                            </button>
                            <button className="qc-failure-submit-button" disabled={isDisabled}>
                                {" "}
                                {form.qcaction === "Rework" ? "Rework" : "Reject"}
                            </button>
                        </div>
                    </form>
                </div>
            </Drawer>
        </>
    );
};

ScanSliderUI.propTypes = {
    formdata: PropTypes.shape({
        NrackAndShelf: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        rackShelf: PropTypes.string,
        NewrackAndShelf: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        bidScanTime: PropTypes.string
    }),
    bid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    created: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClose: PropTypes.func.isRequired,
    clearForm: PropTypes.func,
    emptyDecode: PropTypes.func.isRequired,
    onScannerOpen: PropTypes.func.isRequired,
    title: PropTypes.string,
    placement: PropTypes.string,
    visible: PropTypes.bool.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    rejectType: PropTypes.array
};

export default ScanSliderUI;
